import { Component, OnInit, Signal, WritableSignal, computed, inject, signal } from '@angular/core';
import { map } from 'rxjs';

import { SessionService } from '../../services/session.service';
import { ShipService } from '../../services/ship.service';
import { TransactionService } from '../../services/transaction.service';

import { Transaction } from '../../interfaces/transaction';
import { Race } from '../../interfaces/race';
import { CampaignWithRace } from '../../base/campaign-race';

@Component({
    selector: 'simple-list',
    templateUrl: './simple-list.component.html',
    standalone: false
})
export class SimpleListComponent extends CampaignWithRace implements OnInit {
  private transactionService = inject(TransactionService);
  private shipService = inject(ShipService);

  // extending class MUST override startUpTitle and filter
  pageTitle: string = "Simple List";
  listKey: string = "unassigned";
  displayType: string = 'Ship';

  transactions: WritableSignal<Transaction[]> = signal<Transaction[]>([]);
  shipNames = {};
  shipClassHash = {};
  shipClassList = [];
  total: Signal<number>;

  constructor () {
    super();
    this.session.iAmBusy();
    this.total = computed(() => {
      return this.transactions().reduce(
        (sum, transaction) => (sum + transaction.amount), 0
      );
    });
  };

  ngOnInit () {
    this.transactionService.getOrBuildTransactions(this.race(), this.session.turnEdit()).pipe(
      map(transactions => transactions.filter(t => t.type === this.listKey)),
    ).subscribe(
      transactions => this.transactions.set(transactions)
    );

    if (this.displayType === 'Ship') {
      this.shipService.getShipsForRaceId$(this.race()._id).subscribe(
        shipData => {
          this.shipNames = shipData.reduce(
            function (names, ship) {
              names[ship._id] = ship.shipName;
              return names;
            }, {}
          );
        }
      );
    }

    setTimeout(() => this.session.iAmNotBusy());
  };
};
